const getActiveAuthStorage = () => {
  if (sessionStorage.getItem("token") && sessionStorage.getItem("user")) {
    return sessionStorage;
  }
  if (localStorage.getItem("token") && localStorage.getItem("user")) {
    return localStorage;
  }
  if (sessionStorage.getItem("token")) return sessionStorage;
  if (localStorage.getItem("token")) return localStorage;
  return null;
};

export const getStoredToken = () => getActiveAuthStorage()?.getItem("token") || null;

export const getStoredUser = () => {
  const storage = getActiveAuthStorage();
  const raw = storage?.getItem("user");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const syncStoredUser = (user) => {
  const storage = getActiveAuthStorage();
  if (storage?.getItem("token")) {
    storage.setItem("user", JSON.stringify(user));
  }
};

export const clearStoredAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
};
